import { StoreState } from '@/redux/types';
import { selectBasketItems } from './selectBasketItems';

export const getBasketItem = (state: StoreState, itemId: string) =>
  selectBasketItems(state).find((i) => i.id === itemId);
